<section class="auth">
  <aside class="auth-panel">
    <p class="kicker light">{{ lang.t('inKicker') }}</p>
    <h1>{{ lang.t('inH') }}</h1>
    <p>{{ lang.t('inP') }}</p>
    <ol>
      <li><strong>{{ lang.t('inSpeed') }}</strong> {{ lang.t('inSpeedB') }}</li>
      <li><strong>{{ lang.t('inSec') }}</strong> {{ lang.t('inSecB') }}</li>
      <li><strong>{{ lang.t('inRel') }}</strong> {{ lang.t('inRelB') }}</li>
    </ol>
  </aside>

  <form class="auth-form" [formGroup]="form" (ngSubmit)="submit()">
    <p class="kicker">{{ lang.t('inTitle') }}</p>
    <h2>{{ lang.t('inTitle') }}</h2>

    @if (serverError(); as message) {
      <p class="banner" role="alert">{{ message }}</p>
    }

    <label>
      {{ lang.t('inEmail') }}
      <input type="email" formControlName="email" autocomplete="email" />
      @if (form.controls.email.touched && form.controls.email.invalid) {
        <small>{{ lang.t('inEmailErr') }}</small>
      }
    </label>

    <label>
      {{ lang.t('inPass') }}
      <input type="password" formControlName="password" autocomplete="current-password" />
      @if (form.controls.password.touched && form.controls.password.invalid) {
        <small>{{ lang.t('inPassErr') }}</small>
      }
    </label>

    <button class="btn primary" type="submit" [disabled]="submitting()">
      {{ submitting() ? lang.t('inBusy') : lang.t('inTitle') }}
    </button>
    <p class="fine">{{ lang.t('inNew') }} <a routerLink="/signup">{{ lang.t('inCreate') }}</a>.</p>
  </form>
</section>
